var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Teleport',{staticClass:"mobile-full-screen-modal",attrs:{"to":"body"}},[_c('transition',{attrs:{"name":"el-fade-in-linear"}},[(_vm.modalVisible)?_c('div',{staticClass:"mobile-full-screen-modal__mask",on:{"click":() => {
                    _vm.modalVisible = false
                }}}):_vm._e()]),_c('transition',{attrs:{"name":"scale-fade"}},[(_vm.modalVisible)?_c('div',{staticClass:"mobile-full-screen-modal__content"},[_c('div',{staticClass:"content-close",on:{"click":() => {
                        _vm.modalVisible = false
                    }}}),_c('div',{staticClass:"content-slot"},[_vm._t("content")],2)]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }